export default (cb) => {
  const verticalScrollMax = document.body.clientHeight - window.innerHeight;
  let scrollPosition;
  if (verticalScrollMax > 0) {
    const verticalScrollPos = window.pageYOffset || document.body.scrollTop;
    scrollPosition = (verticalScrollPos / verticalScrollMax) * 100;
    cb(scrollPosition);
  }
  const horizontalScrollMax = document.body.clientWidth - window.innerWidth;
  if (horizontalScrollMax > 0) {
    const horizontalScrollPos = window.pageXOffset || document.body.scrollLeft;
    scrollPosition = (horizontalScrollPos / horizontalScrollMax) * 100;
    cb(scrollPosition);
  }
  return scrollPosition;
};



// WEBPACK FOOTER //
// ./src/components/Parallax/utils/scroll.js